module.exports = __webpack_public_path__ + "static/media/5.e57e75c5.JPG";